export default {
  "Icon" : require("./images/Icon.png"),
  "SplashBackground" : require("./images/SplashBackground.png"),
  "ZipPlusTruck" : require("./images/ZipPlusTruck.png"),
  "logo_transparent" : require("./images/logo_transparent.png"),
  "track_truck" : require("./images/track_truck.png")
};
